var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-table-column", {
    attrs: { "class-name": "menu" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(scope) {
          return [
            _c(
              "el-dropdown",
              { on: { command: _vm.handleContent } },
              [
                _c(
                  "span",
                  { staticClass: "el-dropdown-link" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "operateIcon",
                        attrs: { slot: "reference" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        },
                        slot: "reference"
                      },
                      [_c("i", { staticClass: "el-icon-more" })]
                    )
                  ],
                  1
                ),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      { attrs: { command: _vm.handleCopy(scope.row) } },
                      [_vm._v("コピー登録")]
                    ),
                    _c(
                      "el-dropdown-item",
                      {
                        attrs: {
                          command: _vm.handleDelete(scope.row),
                          disabled: !_vm.deletable(scope.row, scope.$index)
                        }
                      },
                      [_vm._v("削除")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }